import { getData, replaceDrugData, deleteReferenceData } from "./idb";

const STORE_NAME = "drugData";

const ORANGE_BOOK_DATA_KEY = "orangeBook.data";
const ORANGE_BOOK_METADATA_KEY = "orangeBook.meta";

export async function getOrangeBookDataFromDb() {
  return await getData(STORE_NAME, ORANGE_BOOK_DATA_KEY);
}

export async function getOrangeBookMetadataFromDb() {
  return await getData(STORE_NAME, ORANGE_BOOK_METADATA_KEY);
}

export async function saveOrangeBookToDb(data, metadata) {
  validateOrangeBookData(data);

  const storedMetadata = {
    ...metadata,
    recordCount: data.length,
    downloadedAt: new Date().toISOString()
  };

  await replaceDrugData(
    ORANGE_BOOK_DATA_KEY,
    data,
    ORANGE_BOOK_METADATA_KEY,
    storedMetadata
  );

  console.log("DB Updated: ", metadata);
  return storedMetadata;
}

export async function deleteOrangeBookFromDb() {
  await Promise.all([
    deleteReferenceData(ORANGE_BOOK_DATA_KEY),
    deleteReferenceData(ORANGE_BOOK_METADATA_KEY)
  ]);
}

function validateOrangeBookData(data) {
  if (!Array.isArray(data)) {
    throw new Error("Orange Book data is not an array");
  }

  if (data.length === 0) {
    throw new Error("Orange Book data is empty");
  }

  const firstRecord = data[0];

  if (!firstRecord || typeof firstRecord !== "object") {
    throw new Error("Orange Book records are invalid");
  }
}
